import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loadSupportTicketComments } from "../supportTickets/supportTicketsSlice";

export const createComment = createAsyncThunk(
    'commentForm/createComment',
    async ({newComment, token}) => {
        const requestBody = JSON.stringify(newComment);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/supportTicket/createComment`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const createCommentAndLoadComments = createAsyncThunk(
    'commentForm/createCommentAndLoadComments',
    async ({newComment, token}, {dispatch}) => {
        const newCommentResult = await dispatch(createComment({newComment, token}));

        if (createComment.fulfilled.match(newCommentResult)) {
            dispatch(loadSupportTicketComments({supportTicketId: newComment.supportTicketId, token}));
        }
    }
)

export const commentFormSlice = createSlice({
    name: 'commentForm',
    initialState: {
        commentText: '',
        submittingComment: false,
        failedToSubmitComment: false,
        commentErrorMessage: ''
    },
    reducers: {
        changeCommentText: (state, action) => {
            return {
                ...state,
                commentText: action.payload
            }
        },
        clearComment: (state) => {
            return {
                ...state,
                commentText: ''
            }
        },
        changeCommentErrorMessage: (state, action) => {
            return {
                ...state,
                commentErrorMessage: action.payload
            }
        }
    },
    extraReducers: {
        [createComment.pending]: (state) => {
            return {
                ...state,
                submittingComment: true,
                failedToSubmitComment: false
            }
        },
        [createComment.fulfilled]: (state) => {
            return {
                ...state,
                submittingComment: false,
                failedToSubmitComment: false,
                commentText: ''
            }
        },
        [createComment.rejected]: (state) => {
            return {
                ...state,
                submittingComment: false,
                failedToSubmitComment: true
            }
        }
    }
})

export const selectCommentText = (state) => state.commentForm.commentText;
export const selectCommentErrorMessage = (state) => state.commentForm.commentErrorMessage;
export const commentIsSubmitting = (state) => state.commentForm.submittingComment;
export const commentFailed = (state) => state.commentForm.failedToSubmitComment;

export const {
    changeCommentText,
    clearComment,
    changeCommentErrorMessage
} = commentFormSlice.actions;

export default commentFormSlice.reducer;